<script>
/**
 * Concept Quicktable
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */
import {captions, captionsForUser, baseIndex as fetchingAPI, getCorrectAPI} from './archetype.js'

import QuickCardFooter from '@/views/elements/quick-card-footer.vue'
import axios from 'axios'
import automodal from './automodal.vue'

let name = 'MonederoQuicktable',
    newButtonLabel = 'New',
    emptyHeader = 'Data not found',
    emptyLead =  'Module empty',
    reloadData = 'Try reloading this page',
    tryAgainLater  = '',
	header = null,
	footer = null;

export default {
	name,

    components: {automodal, QuickCardFooter},

	props: {
		usuarioId: {
			type: [Number, String]
		},
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 10,
		},
		footer: {
			type: String,
			default: () => { return footer }
		},
		captions: {
			type: [Array, Object],
			default: () => captions
		}
	},
	
	computed: {
		computedCaptions(){
			return (this.usuarioId) ? captionsForUser : this.captions
		},
		sourceURI() {
			let init = getCorrectAPI(this.usuarioId) + "/" + this.perPage + "/" + this.currentPage;
			if (!!this.term) {
				init += "/" + this.term;
			} else if (!this.term || this.term == "s") {
				init += "/@";
			}
			return init;
		}
	},
	
	data: () => {
		return {
			name, newButtonLabel, emptyHeader,
            emptyLead, tryAgainLater, reloadData,
			currentPage: 1,
			items: [],
			itemsCount: 0,
			term: null,
			isLoading: false
		}
	},
	
	methods: {
        async refreshFromStart(){
            this.currentPage = 1
            this.refresh()
        },
		async refresh(){
			this.isLoading = true
			await this.loadUp()
			this.isLoading = false
		},
		async loadUp(){
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.loading = false;
				this.$emit('updated')
			} catch (error) {
				console.error(error)
			}
		}
	},

	watch: {
		currentPage(a, b) {
			this.refresh();
		},
		'$route'(){
			this.loadUp()
		}
	},

	mounted() {
        this.refresh()
	}
};
</script>

<template>

	<div  :id="name">
		<b-card no-body>

			<!-- TABLE CONTENT -->
			<b-table v-if="items.length && !isLoading" class="animated fadeIn" responsive :items="items" :fields="computedCaptions">

				<template #cell(usuario_id_pk_auditor)="data">
					<strong v-if="data.value">{{data.item.nombreCompletoRev}}</strong>
					<strong v-else> -- </strong>
					<div class="block"><small v-b-tooltip.hover title="Creación" >{{data.item.created | humanizar_fecha}}</small></div>
					<div class="comments" v-if="data.item.concepto || data.item.comentarios">
						<div v-if="data.item.concepto" class="block"><strong v-b-tooltip.hover title="Concepto" >{{data.item.concepto}}</strong></div>
						<div v-if="data.item.comentarios" class="block"><small v-b-tooltip.hover title="Comentarios" >{{data.item.comentarios}}</small></div>		
					</div>
				</template>

				<template #cell(cantidad)="data">
					<strong>{{data.value | currency}}</strong>
				</template>

				<template #cell(imagen_transferencia)="data">
					<img-portal :src="data.value" size="128/128" :thumbnail="true" :allow-zoom="true"/>
				</template>

				<template #cell(imagen)="data">
					<img-portal :src="data.value" size="128/128" :thumbnail="true" :allow-zoom="true"/>
				</template>

				<template #cell(_)="data">
					<!-- <pre>{{ data.item }}</pre> -->
					<automodal :concept-id="data.item.id" @refresh="refresh">
						Editar
					</automodal>
				</template>

			</b-table>

			<!-- LOADING SPINNER -->

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

			<!-- EMPTY JUMBOTRON -->

			<div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
				<b-jumbotron :header="emptyHeader" :lead="emptyLead">
					<p>{{tryAgainLater}}</p>
					<b-button variant="primary" @click="refresh()">{{reloadData}}</b-button>
				</b-jumbotron>
			</div>

			<!-- HEADER -->

			<template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{header}}</h6>
					</b-col>

					<b-col>
						<b-input-group>
							<b-form-input v-model="term" @keyup.enter="refreshFromStart()" placeholder="Buscador..." />
							<b-input-group-append>
								<b-button v-if="!!term"  variant="secondary" @click="term = ''; refreshFromStart();"><i class="fa fa-times"></i></b-button>
								<b-button variant="secondary" @click="refreshFromStart()" :disabled="!term"><i class="fa fa-search"></i></b-button>
							</b-input-group-append>
						</b-input-group>
					</b-col>

					<b-col md="auto" class="align-right">
						<automodal @refresh="refresh" :predefined-user-id="usuarioId">
							Nuevo
						</automodal>
					</b-col>

				</b-row>
			</template>

			<!-- FOOTER -->

			<template v-slot:footer v-if="!isLoading && items.length">
				<quick-card-footer :items-count="itemsCount" :per-page="perPage" v-model="currentPage" @refresh="refresh" :items-fetched="items.length"/>
			</template>

		</b-card>
	</div>

</template>

<style scoped>
	.comments {
		margin-top: 0.5em;
		background-color: var(--light);
		padding: 0.5em;
		border-radius: +0.5em;
	}
</style>